import React from 'react';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
export const LoanpaymentIcon = (props) => {
    const { serviceID, value } = props;
    const classes = commonStyle();
    let colorNonSelected = classes.svg_non_selected;
    let colorSelected = classes.svg_selected;
    if (serviceID !== value) {
        colorSelected = classes.svg_non_selected;
    }

    return (
        <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style={{ enableBackground: 'new 0 0 512 512' }}
        >
            <path
                className={colorNonSelected}
                d="M484.6,249.9c2.6-3,3.8-6.7,3.7-10.2c-1-44.2-19.1-83.7-57.9-104.5c-23.8-12.7-51.6-16.5-78.6-16
	c0.1,0-1.4,1.9,33.9-45.4c23.6-28.3,4.8-71.3-31.7-73.6c-3.2-0.2-6.3-0.4-10,1.7c-1.4,0.8-2.8,1.8-3.9,3
	C340,5,323.8,21.8,296.2,30.4C283.4,9.6,261.8,2.1,260.7,1.8c-3.1-1-6.6-1.1-10,0.2c-12.5,4.5-26.7,14.9-35,28.5
	c-14.9-4.6-32.1-14.1-43.3-25.1c-1.9-1.9-3.6-3.6-6.9-4.6c-1.3-0.4-3-0.7-4.6-0.7c-38.3,0-58.9,44.5-34.6,73.7l33.9,45.4
	c-15.2-0.3-30.4,0.8-45.1,4c-60,13-90.1,58.3-91.4,116.5c-0.2,8.3,6.4,15.1,14.7,15.3s15.1-6.4,15.3-14.7
	c0.5-22.6,6.6-53.7,32.7-72.8c21.7-15.9,51.3-19.3,77.9-18.2c-99.1,136.4-96.6,133-96.8,133.3c-46.1,67-22.9,159,48.6,196.1
	c3.6,1.9,5.5,2.7,10.1,4.8c85.8,38,173.7,38,259.5,0c2.5-1.1,5.1-2.3,7.6-3.5c70.9-34.9,96.3-123.7,55.2-191.1
	c-3.8-6.2,3.2,3.7-100.9-139.6c26.7-1.1,56.2,2.3,77.9,18.2c26.1,19.2,32.2,50.2,32.7,72.8C458.6,254.1,475.7,260.1,484.6,249.9z
	 M421.5,302.2c34.5,53.6,13.8,125.6-44,152.1c-80.7,37-162.2,37-242.9,0c-58.1-26.6-78.4-98.8-44-152.1c1.8-2.8-6.6,8.9,108.3-149.3
	c9.8,1.6,20.2,3.7,30.9,6.3c-3.7,14.4-10.8,28.5-22.7,37.5c-9.5,7.1-7.3,21.8,3.6,26c1.4,0.5,3.3,1,5.4,1c5.6,0,8.9-2.8,12.6-5.9
	c13-11,21.9-25.8,27.4-42.1c5.6,16.4,14.5,31.1,27.4,42.1c3.8,3.2,7,5.9,12.6,5.9c1.7,0,3.6-0.3,5.4-1c11-4.2,13.1-18.9,3.7-26
	c-11.9-8.9-18.9-23.1-22.7-37.5c0.4,0,12.6-3.3,30.9-6.3C428.7,311.9,419.7,299.4,421.5,302.2L421.5,302.2z M150,55.5
	c-0.9-1.2-4.4-4.7-4.2-10.9c0.3-6.5,4.5-11.9,10-13.8c15,13.1,35,24.1,56.8,29.9c1.9,0.5,8.6,2.2,10.4,2.2c7,0.5,13.2-3.9,15.3-10.2
	c2.3-7,7.1-12.9,13.2-17.3c3.1-2.2,4.5-2.8,4.5-2.9c0.1,0,0,0,0.1,0c0.9,0.2,5.4,3.4,8,5.7c8.3,7.5,9.2,13.9,10.8,16.9
	c1.3,2.4,3.3,4.5,6,6c5.1,2.8,9.3,1.9,14.9,0.5c23.8-6,44.1-16.5,60.5-30.9c8.7,3,13.2,14.4,7.2,22.8c-0.9,1.2,0,0-2.9,3.8
	c-3.2,4.2-18.4,24.7-48.8,65.3c-18.6,2.9-37.6,7.3-55.7,12.3c-17.9-5.1-37-9.5-55.7-12.3C200.2,122.8,199.5,121.7,150,55.5L150,55.5
	z"
            />
            <path
                className={colorSelected}
                d="M190.7,272h56.1c14.8,0,27.5,9.6,32.1,22.9h-88.1V317h88.1c-4.6,13.3-17.2,22.9-32.1,22.9h-56.1v24.2l87,87
	l15.6-15.6L219.9,362h26.9c27.1,0,49.8-19.4,55-45h21.6v-22.1h-21.6c-1.7-8.5-5.3-16.2-10.4-22.9h32v-22.1H190.7V272L190.7,272z"
            />
        </svg>
    );
};
